export const TspRoute = {
  Dashboard: '/dashboard',
  CompanyProfile: '/profile',
};
